const _ = require('lodash');
const moment = require('moment');
const PropTypes = require('prop-types');
const React = require('react');
const createReactClass = require('create-react-class');
const Immutable = require('immutable');
const Mui = require('@mui/material');
const App = require('@gral/app');
const act = require('@flux/actions/actView');
const Mixin = require('@utils/mixin/mixin');
const Misc = require('@components/Misc');
const Error403 = require('@components/Errors/403').default;

const ContactDataTable = require('./ContactDataTable').default;

const { withTranslation } = require('react-i18next');
// -=======================================================
const contactData = createReactClass({
  displayName: 'ContactData',
  mixins: [Mixin.Base, Mixin.Needs],

  //-----------------------------------------------------
  propTypes: {
    app: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    xTypeId: PropTypes.string,
    settedContactDatas: PropTypes.array,
  },

  getInitialState() {
    return { selectedContactData: null };
  },

  componentWillUnmount() {
    act.deleteResource('contactDataTypes');
    return act.deleteResource('contactDatas');
  },

  UNSAFE_componentWillMount() {
    if (this.props.entity) {
      if (!App.cxStore.checkPermission(this.props.entity, 'read')) {
        this._NOT_AUTHORIZED = true;
      }
    }

    this.iNeed({ url: '/api/contactDataTypes', dataPath: 'contactDataTypes' });
    const { apiBaseUrl } = this.props;
    const baseUrl = apiBaseUrl ? `${apiBaseUrl}` : '/api';
    return this.iNeed({
      url: `${baseUrl}/${this.props.type}/${this.props.xTypeId}`,
      dataPath: 'contactDatas',
    });
  },

  //-----------------------------------------------------
  render() {
    let fDisabled;
    if (this._NOT_AUTHORIZED === true) {
      return <Error403 />;
    }

    this._contactDataTypes = __guard__(this.props.data.getIn(['contactDataTypes', 'data']), x => x.toJS());
    this._entity = this.props.data.getIn(['contactDatas', 'data']);
    if (!(this._entity && this._contactDataTypes)) {
      return <Misc.Loading />;
    }
    switch (this.props.type) {
      case 'item':
        this._settedContactDatas = __guard__(this._entity.getIn(['flavors', 'person', 'personData', 'XPDCDs']), x1 =>
          x1.map(xP => xP.get('ContactData'))
        );
        this._entityType = 'personData';
        this._entityTypeId = this._entity.getIn(['flavors', 'person', 'personData', 'logicalId']);
        break;
      case 'user':
        this._settedContactDatas = __guard__(this._entity.getIn(['userPersonData', 'XPDCDs']), x2 =>
          x2.map(xP => xP.get('ContactData'))
        );
        this._entityType = 'personData';
        this._entityTypeId = this._entity.getIn(['userPersonData', 'logicalId']);
        break;
      case 'organization':
        this._settedContactDatas = __guard__(this._entity.get('XOCDs'), x3 => x3.map(xP => xP.get('ContactData')));
        this._entityType = 'organization';
        this._entityTypeId = this._entity.getIn(['logicalId']);
        break;
      default:
        console.log('UNKNOWN TYPE');
    }

    if (this.props.entity) {
      fDisabled = !App.cxStore.checkPermission(this.props.entity, 'edit');
    } else {
      fDisabled = false;
    }

    return (
      <ContactDataTable
        {...this.props}
        contactDatas={this._settedContactDatas}
        title={this.props.t('Contact Information')}
        editDataPath="editContactData"
        collectionDataPath="contactDatas"
        fAllowQuickSearch={false}
        fAllowEdit
        fAllowCreate
        defaultCreationProperties={Immutable.Map({
          entityType: this._entityType,
          xTypeId: this._entityTypeId,
        })}
        editUrl="/contactData"
        entity={this.props.entity}
      />
    );
  },
});

export default withTranslation()(contactData);
//-----------------------------------------------------

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
